import { render } from "./PreLoader.vue?vue&type=template&id=173df7f0&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=173df7f0&scoped=true&lang=css"

import exportComponent from "/var/www/appp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173df7f0"]])

export default __exports__